// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToggleSwitch_switch__7MfJz {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 28px;
  margin-top: 8px;
  margin-right: 1rem;
}
.ToggleSwitch_switch__7MfJz input {
  opacity: 0;
  width: 0;
  height: 0;
}

.ToggleSwitch_slider__34SgC {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 28px;
}

.ToggleSwitch_slider__34SgC:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .ToggleSwitch_slider__34SgC {
  background-color: #BCCF02;
}

input:focus + .ToggleSwitch_slider__34SgC {
  box-shadow: 0 0 1px #BCCF02;
}

input:checked + .ToggleSwitch_slider__34SgC:before {
  transform: translateX(20px);
}

input:disabled + .ToggleSwitch_slider__34SgC {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/ToggleSwitch/ToggleSwitch.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EAEA,eAAA;EACA,kBAAA;AAAF;AACE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AACJ;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EAGE,2BAAA;AAAF;;AAGA;EACE,mBAAA;AAAF","sourcesContent":[".switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 28px;\n  margin-top: 8px;\n  margin-right: 1rem;\n}\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 28px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #BCCF02;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #BCCF02;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(20px);\n  -ms-transform: translateX(20px);\n  transform: translateX(20px);\n}\n\ninput:disabled + .slider {\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `ToggleSwitch_switch__7MfJz`,
	"slider": `ToggleSwitch_slider__34SgC`
};
export default ___CSS_LOADER_EXPORT___;
